module.exports = __webpack_public_path__ + "img/SOEs.e34760cf.jpg";